import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import { Box, Heading } from "@chakra-ui/react";
import { useState, useEffect } from "react";

import { PieChartPercentComponent } from "../charts/PieChartComponent";

// สีของแต่ละเขต
const COLORS = [
    "#FF6F61", "#FFA07A", "#FFD700", "#32CD32", "#4682B4", 
    "#9932CC", "#FF69B4", "#20B2AA", "#FF4500"
  ];

// รายชื่อเขต
const REGIONS = ["เขต 1", "เขต 2", "เขต 3", "เขต 4", "เขต 5", "เขต 6", "เขต 7", "เขต 8", "เขต 9"];

// ฟังก์ชันสุ่มจำนวนความต้องการวัคซีน และคำนวณ %
const generateRandomData = () => {
  let rawData = REGIONS.map(region => ({
    name: region,
    value: Math.floor(Math.random() * 1500) + 500 // สุ่มค่าระหว่าง 500-2000
  }));

  // คำนวณเปอร์เซ็นต์
  const total = rawData.reduce((sum, item) => sum + item.value, 0);
  const percentageData = rawData.map(item => ({
    ...item,
    percentage: ((item.value / total) * 100).toFixed(2) // คำนวณ % และปัดทศนิยม 2 ตำแหน่ง
  }));

  return percentageData;
};

// คำอธิบายประเภทวัคซีน
const VACCINE_TYPES = {
  pig: "สุกร",
  cow: "โค กระบือ",
  poultry: "สัตว์ปีก"
};

export function VaccineDemandPieChart({ type }) {

  const [data, setData] = useState([]);

  // โหลดข้อมูลใหม่เมื่อเปลี่ยนประเภทวัคซีน
  useEffect(() => {
    setData(generateRandomData());
  }, [type]);

  const getTheme = (type) => {
    switch (type) {
      case "pig":
        return "purple";
      case "cow":
        return "orange";
      case "poultry":
        return "blue";
      default:
        return "gray";
    }
  };

  return (
    <Box w="100%" m={5} textAlign={"center"}>
      <Heading size="md" mb={4}>
        สัดส่วนความต้องการวัคซีนสำหรับ {VACCINE_TYPES[type] || "ไม่ระบุ"}
      </Heading>
      <PieChartPercentComponent data={data} theme={getTheme(type)} width={500} height={300} />
      
    </Box>
  );
}
